import { ADDON_PRODUCTS, productNameMatches } from './config.js';
import { subscriptionIncludesProduct } from './subscriptionLines.js';

const ACTIVE_STATUSES = new Set(['active', 'trialing', 'past_due']);

function listActive(subscriptions = []) {
  return subscriptions.filter((s) => ACTIVE_STATUSES.has(String(s.status ?? s.Status).toLowerCase()));
}

/**
 * @param {string[]} [addOns]
 * @param {object[]} [subscriptions]
 * @param {object | null} [catalog]
 */
export function addonEntitlementsFromAccount(addOns = [], subscriptions = [], catalog = null) {
  const labels = (addOns || []).map((s) => String(s).toLowerCase());
  const active = listActive(subscriptions);

  // Same matcher the catalog and subscription-line checks use
  // (config.productNameMatches). These were bare substring tests, so
  // includes("mcp") also matched names like "webmcp".
  const fromOverview = {
    analyzer: labels.some((s) => productNameMatches(ADDON_PRODUCTS.analyzer, s)),
    dedicated: labels.some((s) => productNameMatches(ADDON_PRODUCTS.dedicated, s)),
    mcp: labels.some((s) => productNameMatches(ADDON_PRODUCTS.mcp, s))
  };

  const fromSubs = {
    analyzer: subscriptionIncludesProduct(active, ADDON_PRODUCTS.analyzer, catalog),
    dedicated: subscriptionIncludesProduct(active, ADDON_PRODUCTS.dedicated, catalog),
    mcp: subscriptionIncludesProduct(active, ADDON_PRODUCTS.mcp, catalog)
  };

  // EA Hosting is deliberately absent: it is a standalone product, not an
  // add-on, and its entitlement (plus slot count and suspension state) is
  // served by ea-manager's GetHostingOverview — not inferred from billing
  // labels. See findActiveEaHosting in eaHostingBilling.js for the
  // subscription-side lookup the slot-change flow uses.
  return {
    analyzer: fromOverview.analyzer || fromSubs.analyzer,
    dedicated: fromOverview.dedicated || fromSubs.dedicated,
    // MCP (AI Trading) is single-instance per user like analyzer.
    mcp: fromOverview.mcp || fromSubs.mcp
  };
}
